import { render, staticRenderFns } from "./pcA.vue?vue&type=template&id=ed89e862&scoped=true"
import script from "./pcA.vue?vue&type=script&lang=js"
export * from "./pcA.vue?vue&type=script&lang=js"
import style0 from "./pcA.vue?vue&type=style&index=0&id=ed89e862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed89e862",
  null
  
)

export default component.exports